<template>
  <svg class="page-node-arrow"
       :class="[{ disabled: disabled }, {shadow: shadow}]"
       :style="{ top: positionY,
                 left: positionX,
                 width: (width + 100) + 'px',
                 height: height + 'px' }">
    <defs>
      <linearGradient :id="`arrowGradientColor${_uid}`">
        <stop offset="0" :stop-color="realStartColor"/>
        <stop :offset="50 / lineWidth * 100 + '%'" :stop-color="realEndColor"/>
      </linearGradient>
      <linearGradient :id="`arrowGradient${_uid}`"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      :xlink:href="`#arrowGradientColor${_uid}`"/>
      <marker :id="`head${_uid}`"
              orient="auto"
              refX="0.05"
              :refY="markerWidth / 2">
        <path :d="`M0,0
                 V${markerWidth}
                 L${markerHeight},${markerWidth / 2}
                 Z`"
              :fill="realEndColor"
              stroke="none" />
      </marker>
    </defs>
    <path fill="none"
          :marker-end='`url(#head${_uid})`'
          :stroke="`url(#arrowGradient${_uid})`"
          :stroke-width="weight"
          :d="`M100,${start}
               l5,0
               C${bezierAtStartX + 95},${bezierAtStartY}
               ${bezierAtEndX + 100},${bezierAtEndY}
               ${lineWidth + 100},${end - 0.0002}`" />
    <path fill="none"
          stroke="none"
          :id="`arrow-${bezierAtStartX}-${bezierAtStartY}-${bezierAtEndX}-${bezierAtEndY}`"
          :d="`M80,${start}
               l25,0
               C${bezierAtStartX + 95},${bezierAtStartY}
               ${bezierAtEndX + 100},${bezierAtEndY}
               ${lineWidth + 100},${end - 0.0002}
               l${arrowWeight * 2},0`" />

    <template v-if="active">
      <path opacity="0.4"
            fill="transparent"
            :stroke="arrowColor"
            :d="`M0,${-weight / 2 - 1}
                 l${weight / 2 + 1},${weight / 2 + 1}
                 l${-weight / 2 - 1},${weight / 2 + 1}`"
            :stroke-width="arrowWeight">
        <animateMotion :dur="`${arrowTime}s`"
                       calcMode="spline"
                       keyTimes="0;1"
                       keySplines="1, 0.3, 0.45, 1"
                       rotate="auto"
                       repeatCount="indefinite">
          <mpath :xlink:href="`#arrow-${bezierAtStartX}-${bezierAtStartY}-${bezierAtEndX}-${bezierAtEndY}`"></mpath>
        </animateMotion>
      </path>
      <path opacity="0.8"
            fill="transparent"
            :stroke="arrowColor"
            :d="`M0,${-weight / 2 - 1}
                 l${weight / 2 + 1},${weight / 2 + 1}
                 l${-weight / 2 - 1},${weight / 2 + 1}`"
            :stroke-width="arrowWeight">
        <animateMotion :dur="`${arrowTime}s`"
                       calcMode="spline"
                       keyTimes="0;1"
                       keySplines="0.5, 0.1, 0.4, 1"
                       rotate="auto"
                       repeatCount="indefinite">
          <mpath :xlink:href="`#arrow-${bezierAtStartX}-${bezierAtStartY}-${bezierAtEndX}-${bezierAtEndY}`"></mpath>
        </animateMotion>
      </path>
    </template>
  </svg>
</template>

<script>
export default {
  name: 'BaPageNodeArrow',
  props: {
    positionX: {},
    positionY: {},
    active: {},
    width: {},
    height: {},
    maxOverlap: {},
    start: {},
    end: {},
    time: {},
    weight: {},
    index: {},
    disabled: {},
    from: {},
    to: {},
    startColor: {
      default: '#ecede6'
    },
    endColor: {
      default: '#97bd12'
    },
    disabledStartColor: {
      default: '#ecede6'
    },
    disabledEndColor: {
      default: '#d2dea8'
    },
    shadow: {
      default: false
    }
  },
  computed: {
    arrowTime () {
      if (this.time) {
        return this.time
      }
      return 2 / this.width * (Math.abs(this.end - this.start) / 2 + this.width)
    },
    realStartColor () {
      if (this.disabled) {
        return this.disabledStartColor
      }
      return this.startColor
    },
    realEndColor () {
      if (this.disabled) {
        return this.disabledEndColor
      }
      return this.endColor
    },
    bezierAtStartX () {
      return (this.lineWidth) / 2 - (this.maxOverlap * 2) + 30 + (this.active ? 10 : 0)
    },
    bezierAtStartY () {
      return this.start
    },
    bezierAtEndX () {
      return Math.max((this.lineWidth / 2) - Math.abs(this.end - this.start) / (this.maxOverlap + 2) + (this.active ? 20 : 0) - Math.abs(this.end - this.start) * 0.005, -Math.abs(this.end - this.start) * 0.5)
    },
    bezierAtEndY () {
      return this.end
    },
    lineWidth () {
      return this.width - 2 / Math.pow(this.markerHeight, 3.15) - 8
    },
    arrowColor () {
      return this.disabled ? '#dcdcd9' : '#f4f4f1'
    },
    arrowWeight () {
      return 5 - this.weight / 8
    },
    markerWidth () {
      return Math.min(3, 4 / Math.log(this.weight))
    },
    markerHeight () {
      return this.markerWidth * 0.5
    }
  }
}
</script>

<style lang="scss" scoped>
.page-node-arrow {
  position: absolute;
  transform: translateX(-100px);
  transition: all 0.2s ease;
  pointer-events: none;

  stop,
  path,
  marker {
    transition: all 0.2s ease;
  }

  &.disabled {
    z-index: -1 !important;
  }
  &.shadow path {
    filter: drop-shadow(3px 3px 2px rgba(0, 0, 0, 0.16))
  }
}
</style>
